class CustomSubscriptionWidget extends HTMLElement {
    constructor() {
        super();
        this.handleVariantSelected = this.handleVariantSelected.bind(this);
        this.handlePageShow = this.handlePageShow.bind(this);
        this.savedPurchaseOption = null;
        this.savedQuantity = null;
        this.savedSellingPlan = null;
        this.savedCustomQty = false;
        this.savedCustomQtyValue = 1;
    }

    connectedCallback() {
        this.initWidget();
        window.addEventListener("variant:selected", this.handleVariantSelected);
        window.addEventListener("pageshow", this.handlePageShow);
    }

    disconnectedCallback() {
        window.removeEventListener("variant:selected", this.handleVariantSelected);
        window.removeEventListener("pageshow", this.handlePageShow);
    }

    saveSelections() {
        const purchase = this.querySelector('input[name="purchase-option"]:checked');
        this.savedPurchaseOption = purchase?.value || null;

        const quantity = this.querySelector('input[name="quantity_ui"]:checked');
        this.savedQuantity = quantity?.id || null;

        const sellingPlan = this.querySelector('input[name="selling_plan_custom"]:checked');
        this.savedSellingPlan = sellingPlan?.value || null;
    }

    restoreSelections() {
        if (this.savedPurchaseOption) {
            const purchase = this.querySelector(`input[name="purchase-option"][value="${this.savedPurchaseOption}"]`);

            if (purchase) {
                purchase.checked = true;
            }
        }
        if (this.savedQuantity) {
            const quantity = document.querySelector(`#${this.savedQuantity}`);
            if (quantity) {
                quantity.checked = true;
            }
        }

        if (this.savedPurchaseOption === "subscribeandsave") {
            let sellingPlan = null;

            if (this.savedSellingPlan) {
                sellingPlan = this.querySelector(`input[name="selling_plan_custom"][value="${this.savedSellingPlan}"]`);
            }

            if (!sellingPlan) {
                sellingPlan = this.querySelector('input[name="selling_plan_custom"]');
            }

            if (sellingPlan) {
                sellingPlan.checked = true;
            }
        }
        
        this.handlePurchaseChange(true);
        this.handleQuantityChange();
        this.handleSellingPlanChange();
        
        if(this.savedCustomQty) {
            const customQtySelector = this.querySelector('.esa-custom-quantity__selector');
            const inputGroups = this.querySelector('.quantity--inputs');
            customQtySelector.style.display = "block";
            inputGroups.style.display = "none";
            const qtyInput = this.querySelector('.esa-quantity__input');
            qtyInput.value = this.savedCustomQtyValue;
            this.quantityInput.value = this.savedCustomQtyValue;
        }
    }

    handlePageShow() {
        this.resetWidget();
    }

    async handleVariantSelected(event) {
        const sectionId = this.dataset.sectionId;
        const productUrl = this.dataset.productUrl;
        if (!sectionId || !productUrl) return;

        this.saveSelections();

        const variant = event.detail?.resource;
        if (!variant) return;

        const picker = document.querySelector(`variant-picker[data-section-id="${sectionId}"]`);
        if (!picker) return;

        const values = [...picker.querySelectorAll('input[type="radio"][data-option-value-id]:checked')].map(el => el.dataset.optionValueId);
        if (!values.length) return;

        const fetchUrl = `${productUrl}?option_values=${values.join(",")}&section_id=${sectionId}`;

        try {
            const res = await fetch(fetchUrl);
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, "text/html");
            const updated = doc.querySelector(`custom-subscription-widget[data-section-id="${sectionId}"]`);
            if (!updated) return;

            this.innerHTML = updated.innerHTML;
            this.initWidget(true);
            this.restoreSelections();

        } catch (err) {
            console.error("Subscription widget reload failed:", err);
        }
    }

    initWidget(skipPurchaseChange = false) {
        this.purchaseInputs = this.querySelectorAll('input[name="purchase-option"]');
        this.quantityInputs = this.querySelectorAll('input[name="quantity_ui"]');
        this.quantityInput = this.querySelector('input[type="hidden"][name="quantity"]');
        this.sellingPlanInputs = this.querySelectorAll('input[name="selling_plan_custom"]');
        this.sellingPlanInput = this.querySelector('input[type="hidden"][name="selling_plan"]');
        this.pickerContainers = this.querySelectorAll('.esa-subscription__frequency');
        this.quantityOptions = this.querySelectorAll('.option-container-size');

        this.purchaseInputs.forEach(input =>
            input.addEventListener("change", () => this.handlePurchaseChange())
        );

        this.quantityInputs.forEach(input =>
            input.addEventListener("change", () => this.handleQuantityChange())
        );

        this.sellingPlanInputs.forEach(input =>
            input.addEventListener("change", () => this.handleSellingPlanChange())
        );

        this.initCustomQtyHandlers();
        this.initCustomQtyCounter();

        if (!skipPurchaseChange) {
            this.handlePurchaseChange();
        }
    }

    handleQuantityChange() {
        if (!this.quantityInput) return;

        const selectedQuantity = this.querySelector('input[name="quantity_ui"]:checked');

        if (selectedQuantity) {
            this.quantityInput.value = selectedQuantity.dataset.cartQuantity || selectedQuantity.value;
            this.quantityInput.disabled = false;
        }
    }

    handleSellingPlanChange() {
        if (!this.sellingPlanInput) return;

        const selectedPlan = this.querySelector('input[name="selling_plan_custom"]:checked');
        if (selectedPlan) {
            this.sellingPlanInput.value = selectedPlan.value;
            this.sellingPlanInput.disabled = false;
        } else {
            this.sellingPlanInput.value = "";
            this.sellingPlanInput.disabled = true;
        }
    }

    initCustomQtyHandlers() {
        const customOption = this.querySelector('.option-container-custom');
        const customQtySelector = this.querySelector('.esa-custom-quantity__selector');
        const inputGroups = this.querySelector('.quantity--inputs');
        const closeBtn = this.querySelector('.esa-btn-close__selector');
        const allQtyRadios = this.querySelectorAll('.option-container-size input[type="radio"]');
        const customQtyinput = this.querySelector('.esa-quantity__input');

        if (!customOption || !customQtySelector) return;

        customOption.addEventListener("click", () => {

            const selectedPurchase = this.querySelector('input[name="purchase-option"]:checked')?.value;
            if (selectedPurchase === "subscribeandsave") {
                window.location.href = "/products/custom-package";
                return;
            }

            customQtySelector.style.display = "block";
            inputGroups.style.display = "none";

            allQtyRadios.forEach(radio => {
              radio.disabled = true;
            });
            if(customQtyinput)customQtyinput.disabled = false;
            this.quantityInput.value = customQtyinput.value;
            this.savedCustomQty = true;
            this.savedCustomQtyValue = 1;
        });

        closeBtn.addEventListener("click", () => {
            customQtySelector.style.display = "none";
            inputGroups.style.display = "flex";

            allQtyRadios.forEach(radio => radio.disabled = false);

            const firstQty = this.querySelector('.option-container-size:not(.option-container-custom) input[type="radio"]');
            if (firstQty) firstQty.checked = true;
            if (customQtyinput) customQtyinput.disabled = true;
            this.quantityInput.value = this.querySelector('input[name="quantity_ui"]:checked').value;
            customQtyinput.value = 1;
            this.updateQuantityPricing();
            this.savedCustomQty = false;
            this.savedCustomQtyValue = 1;
        });
    }

    initCustomQtyCounter() {
        const minusBtn = this.querySelector('button[name="minus"]');
        const plusBtn = this.querySelector('button[name="plus"]');
        const qtyInput = this.querySelector('.esa-quantity__input');

        if (!minusBtn || !plusBtn || !qtyInput) return;

        minusBtn.addEventListener("click", () => {
            const val = parseInt(qtyInput.value) || 1;
            if (val > 1) qtyInput.value = val - 1;
            if (val > 1) this.quantityInput.value = val - 1;
            this.savedCustomQty = true;
            this.savedCustomQtyValue = qtyInput.value;
            this.updateCustomQtyPricing();
        });

        plusBtn.addEventListener("click", () => {
            const val = parseInt(qtyInput.value) || 1;
            qtyInput.value = val + 1;
            this.quantityInput.value = val + 1;
            this.updateCustomQtyPricing();
            this.savedCustomQty = true;
            this.savedCustomQtyValue = qtyInput.value;
        });

        qtyInput.addEventListener("change", () => {
            const val = parseInt(qtyInput.value);
            qtyInput.value = val < 1 || isNaN(val) ? 1 : val;
            this.updateCustomQtyPricing();
        });

    }

    updateCustomQtyPricing() {
        const qtyInput = this.querySelector('.esa-quantity__input');
        const priceEl = this.querySelector('.esa-variant-price');
        const discountEl = this.querySelector('.esa__quantity-discount-box');

        if (!qtyInput || !priceEl || !discountEl) return;

        const qty = parseInt(qtyInput.value) || 1;
        const base = parseFloat(priceEl.dataset.price);
        const sub = parseFloat(priceEl.dataset.subPrice);
        const baseDiscount = parseInt(discountEl.dataset.discount || 0);
        const subDiscount = parseInt(discountEl.dataset.subDiscount || 0);
        const isSubscription = this.querySelector('input[name="purchase-option"]:checked')?.value === "subscribeandsave";

        const unitPrice = isSubscription ? sub : base;
        let discount = isSubscription ? subDiscount : baseDiscount;
        let discount_text = ''
        if(discount > 0) {
            discount_text = `Save ${discount}%`;
            discountEl.style.display = '';
        } else {
            discountEl.style.display = 'none';
        }

        priceEl.textContent = this.formatMoney(unitPrice);
        discountEl.textContent = discount_text;
    }

    formatMoney(cents) {
        const format = this.dataset.moneyFormat || "$";
        const dollars = (cents / 100).toFixed(2);
        return `${format}${dollars}`;
    }

    handlePurchaseChange(isRestore = false) {

        const selected = this.querySelector('input[name="purchase-option"]:checked')?.value;
        const isSubscription = selected === "subscribeandsave";

        const customQtySelector = this.querySelector('.esa-custom-quantity__selector');
        const inputGroups = this.querySelector('.quantity--inputs');
        const customQtyinput = this.querySelector('.esa-quantity__input');

        if (isSubscription && customQtySelector && inputGroups) {
            customQtySelector.style.display = "none";
            inputGroups.style.display = "flex";

            if(customQtyinput) customQtyinput.disabled = true;

            const allQtyRadios = this.querySelectorAll('.option-container-size input[type="radio"]');
            allQtyRadios.forEach(radio => radio.disabled = false);
        }

        const buyerConsent = document.getElementById("shopify-buyer-consent");
        if (buyerConsent) {
            buyerConsent.style.display = isSubscription ? "" : "none";
        }

        this.pickerContainers.forEach(el => el.style.display = isSubscription ? "block" : "none");
        this.sellingPlanInputs.forEach(input => input.disabled = !isSubscription);

        const sellingPlanInput = this.sellingPlanInput;

        if (isSubscription) {
            let selectedPlan = this.querySelector('input[name="selling_plan_custom"]:checked');
            if (!selectedPlan) {
                selectedPlan = this.querySelector('input[name="selling_plan_custom"]');
                if (selectedPlan) selectedPlan.checked = true;
            }
            if (sellingPlanInput) {
                sellingPlanInput.value = selectedPlan?.value || "";
                sellingPlanInput.disabled = !selectedPlan;
            }

            const customQtySelector = this.querySelector('.esa-custom-quantity__selector');
            const inputGroups = this.querySelector('.quantity--inputs');
            customQtySelector.style.display = "none";
            inputGroups.style.display = "";
            this.quantityInput.value = 2;
            this.savedCustomQty = false;
        } else {
            if (sellingPlanInput) {
                sellingPlanInput.value = "";
                sellingPlanInput.disabled = true;
            }
        }

        const oneTimeQtyEl = this.querySelector('.one-time--qty');
        const subQtyEl = this.querySelector('.subscription--qty');

        if (isSubscription) {
            if (oneTimeQtyEl) {
                oneTimeQtyEl.style.display = "none";
                const input = oneTimeQtyEl.querySelector('input[type="radio"]');
                if (input) input.disabled = true;
            }

            if (subQtyEl) {
                subQtyEl.style.display = "block";
                const input = subQtyEl.querySelector('input[type="radio"]');
                if (input) input.disabled = false;
            }

            if (!isRestore) {
                const qtyInput = this.querySelectorAll('.option-container-size')[1]?.querySelector('input');
                if(qtyInput) {
                    qtyInput.checked = true;
                    qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
                }
            }
        } else {
            if (subQtyEl) {
                subQtyEl.style.display = "none";
                const input = subQtyEl.querySelector('input[type="radio"]');
                if (input) input.disabled = true;
            }

            if (oneTimeQtyEl) {
                oneTimeQtyEl.style.display = "block";
                const input = oneTimeQtyEl.querySelector('input[type="radio"]');
                if (input) input.disabled = false;
            }
            if (!isRestore) {
                const qtyInput = this.querySelectorAll('.option-container-size')[0]?.querySelector('input');
                if(qtyInput) {
                    qtyInput.checked = true;
                    qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
                }
            }
        }
        
        this.updateQuantityPricing(isSubscription);
        this.updateCustomQtyPricing();
    }

    updateQuantityPricing(isSubscription) {
        this.quantityOptions.forEach(option => {
            const priceEl = option.querySelector(".variant-price");
            const discountEl = option.querySelector(".variant-discount");
            if (!priceEl || !discountEl) return;

            const regular = priceEl.dataset.regularPrice;
            const sub = priceEl.dataset.subscriptionPrice;

            const base = parseInt(discountEl.dataset.discount || 0);
            const extra = parseInt(this.querySelector(".esa__discount-perct")?.dataset.discount || 0);

            const final = isSubscription ? base + extra : base;

            discountEl.style.display = final === 0 ? "none" : "flex";

            discountEl.querySelector('span').textContent = `${final}%`;
            priceEl.textContent = isSubscription ? sub : regular;
        });
    }

    resetWidget() {
        const purchaseInputs = this.querySelectorAll('input[name="purchase-option"]');
        const quantityInputs = this.querySelectorAll('.option-container-size input[type="radio"]');
        const sellingPlanInputs = this.querySelectorAll('input[name="selling_plan_custom"]');
        const sellingPlanInput = this.querySelector('input[type="hidden"][name="selling_plan"]');

        const oneTimeInput = this.querySelector('input[name="purchase-option"][value="onetime"]');

        const firstQtyInput = this.querySelector('.option-container-size:not(.option-container-custom) input[type="radio"]');

        const customQtySelector = this.querySelector('.esa-custom-quantity__selector');
        const inputGroups = this.querySelector('.quantity--inputs');
        const customQtyInput = this.querySelector('.esa-quantity__input');

        purchaseInputs.forEach(input => {
            input.checked = false;
        });

        if (oneTimeInput) {
            oneTimeInput.checked = true;
        }

        quantityInputs.forEach(input => {
            input.checked = false;
            input.disabled = false;
        });

        if (firstQtyInput) {
            firstQtyInput.checked = true;
            firstQtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        sellingPlanInputs.forEach(input => {
            input.checked = false;
            input.disabled = true;
        });

        if (sellingPlanInput) {
            sellingPlanInput.value = "";
            sellingPlanInput.disabled = true;
        }

        this.querySelectorAll('.esa-subscription__frequency').forEach(el => {
            el.style.display = "none";
        });

        if (customQtySelector) {
            customQtySelector.style.display = "none";
        }

        if (inputGroups) {
            inputGroups.style.display = "flex";
        }

        if (customQtyInput) {
            customQtyInput.value = "1";
            customQtyInput.disabled = true;
        }

        const oneTimeQtyEl = this.querySelector('.one-time--qty');
        const subQtyEl = this.querySelector('.subscription--qty');

        if (oneTimeQtyEl) {
            oneTimeQtyEl.style.display = "block";

            const input = oneTimeQtyEl.querySelector('input[type="radio"]');

            if (input) {
                input.checked = true;
                input.disabled = false;
            }
        }

        if (subQtyEl) {
            subQtyEl.style.display = "none";

            const input = subQtyEl.querySelector('input[type="radio"]');

            if (input) {
                input.checked = false;
                input.disabled = true;
            }
        }

        const buyerConsent = document.getElementById("shopify-buyer-consent");

        if (buyerConsent) {
            buyerConsent.style.display = "none";
        }

        this.updateQuantityPricing(false);
        this.updateCustomQtyPricing();
    }
}

customElements.define("custom-subscription-widget", CustomSubscriptionWidget);